import * as actions from './actions';
import { SUPPLIER_API, ADMIN_API } from '../../common/configs/path.config';
import { http } from '../../common/services/http.service';
import { showMessage } from './message-notification';

export const getSupplierProfile = (supplierId) => {
	const url = SUPPLIER_API.GET_SUPPLIER_PROFILE + supplierId;
	return http.get(url);
}
